var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42903 24.5158H21.5707C22.1132 24.5158 22.7203 24.0896 22.9011 23.5729L28.2486 8.61542C29.0107 6.47126 28.1194 5.81251 26.2853 7.13001L21.2478 10.7338C20.4082 11.315 19.4524 11.0179 19.0907 10.075L16.8174 4.01709C16.094 2.07959 14.8928 2.07959 14.1694 4.01709L11.8961 10.075C11.5344 11.0179 10.5786 11.315 9.75195 10.7338L5.02445 7.36251C3.00945 5.91584 2.0407 6.65209 2.86736 8.99001L8.0857 23.5988C8.27945 24.0896 8.88653 24.5158 9.42903 24.5158Z",
    stroke: "#EDA600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6035 28.4165H8.39518",
    stroke: "#EDA600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7285 18.0835H12.2702",
    stroke: "#EDA600",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown2);
export default __webpack_public_path__ + "static/media/crown-2.bb78fe6efc2cf7a2b25c20a1a79315d6.svg";
export { ForwardRef as ReactComponent };